import {
  Badge,
  BadgeSettings,
  SelectorItemWithBadgeSettings,
} from '@/settings/types';
import {getColorStyle} from '@/utilities/color-style-map';

/**
 * Reusable logic for PackSizeSelector components
 * to create a badge for a given pack size
 * based on the settings.
 */
export default function createPackSizeBadge(
  packSize: number,
  settings: BadgeSettings
): Badge | null {
  const {
    best_value_one_time_selector,
    best_value_pack_sizes,
    most_popular_one_time_selector,
    most_popular_pack_sizes,
  } = settings;

  if (best_value_pack_sizes.includes(packSize)) {
    return createBadge(best_value_one_time_selector);
  }

  if (most_popular_pack_sizes.includes(packSize)) {
    return createBadge(most_popular_one_time_selector);
  }

  return null;
}

/**
 * Create a badge for a given pack-size selector item based on the settings.
 */
function createBadge(settings: SelectorItemWithBadgeSettings): Badge | null {
  const label = settings.badge_text;
  return label
    ? {
        color: getColorStyle(settings.color ?? ''),
        label,
      }
    : null;
}
